
import { useContext } from 'react'
import { ReduxFormContext } from 'redux-form'

export default function useReduxForm(): any {
  return useContext(ReduxFormContext)
}